<template>
    <main>
        <section id="home-header" class="d-flex flex-column justify-content-center align-items-center pt-4 pb-4">
            <img src="@/assets/img/header-title.png" eager alt="A NEW CHALLENGE BEGINS">
            <p class="header-description">Exiles is carefully crafted to provide endless fun, offering the latest content and exciting grinds. Don't miss out, join today!</p>
            <router-link class="header-play-button" to="/play"><img src="@/assets/img/play-button.png" eager></router-link>
          <!-- <Timer /> -->
        </section>
        <!-- Comment -->
        <!-- <section class="discord-home pt-4 pb-4" id="home-discord">
            <div class="container">
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-12 col-md-12 col-lg-5">
                        <a href="https://discord.com/invite/3yt9kXRdax" target="_blank" class="text-center discord-home--btn">
                            <h5 class="mb-0 text-uppercase">Join our</h5>
                            <h3 class="mb-0 text-uppercase">Discord</h3>
                        </a>
                    </div>
                </div>
            </div>
        </section> -->

        <div class="section-divider"></div>
        <section class="slideshow-section py-5" id="home-video">
            <div class="container">
                <div class="text-center mb-3">
                    <h2>Why Exiles?</h2>
                    <FeatureCards />
                </div>
            </div>
        </section>

        <div class="section-divider"></div>
        <section class="slideshow-section py-5" id="home-video">
            <div class="container">
                <div class="text-center mb-3">
                    <h2>Media</h2>
                    <ImageSlideshow />
                </div>
            </div>
        </section>

        <div class="section-divider"></div>
        <section class="d-flex justify-content-center align-items-center pt-5 pb-5" id="home-video">
            <div class="container">
                <div class="text-center mb-3">
                    <h2>Video</h2>
                    <div class="featured-video-block">
                        <iframe width="50%" height="50%" src="https://www.youtube.com/embed/JXCoBHhzEJ8?si=UqPSe-VHliHYDgzF" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </section>

        <div class="section-divider"></div>
        <section class="pt-3 pb-1" id="home-play">
            <div class="container mt-5 mb-3 text-center">
                <h2>Join the adventure!</h2>
                <router-link class="mt-2 mt-sm-4 section-play-button" to="/play"><img src="@/assets/img/play-button.png"></router-link>
            </div>
        </section>
    </main>
</template>
<script setup>
//import Timer from "@/components/Timer"
import FeatureCards from '@/components/FeatureCards.vue'
import ImageSlideshow from '@/components/ImageSlideshow.vue'
</script>
